import React from 'react';
import { Button } from '@/components/Button/Button';
import { SxProps, useTheme } from '@mui/material';

type Props = {
  children: string;
  loadNextPage: () => Promise<void> | void;
  loading: boolean;
  nextPageExists: boolean;
  sx?: SxProps;
  disableRipple?: boolean;
};

const ShowMoreButton = ({
  children,
  loadNextPage,
  loading,
  nextPageExists,
  sx,
  disableRipple,
}: Props) => {
  const theme = useTheme();

  if (!nextPageExists) return null;

  return (
    <Button
      variant="contained"
      color="info"
      sx={{
        borderRadius: theme.spacing(4),
        minHeight: theme.spacing(13),
        textDecoration: 'underline !important',
        fontSize: theme.spacing(4.5),
        fontWeight: '400 !important',
        ...sx,
      }}
      onClick={() => {
        loadNextPage();
      }}
      loading={loading}
      disableRipple={disableRipple}
    >
      {children}
    </Button>
  );
};

export default ShowMoreButton;
